module.exports = __webpack_public_path__ + "img/10.ce4d2f56.jpg";